import { Dispatch } from 'redux';
import CrudActionContainer from './CrudActionContainer';
import { StoreState } from '../store-interfaces';
import commonHandler from '../errorHandlers/common-handler';
import NotificationsController from '../controllers/NotificationController';

class NotificationsCRUDActions extends CrudActionContainer {
  notificationsSnoozedAction: string;
  notificationsRetrievedAction: string;

  constructor() {
    super('NOTIFICATIONS');
    this.notificationsSnoozedAction = this.makeActionKey(
      'NOTIFICATIONS_SNOOZED_ACTION',
    );
    this.notificationsRetrievedAction = this.makeActionKey(
      'NOTIFICATIONS_RETRIEVED_ACTION',
    );
  }

  retrieveAll(botId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAllAction));

      try {
        const { notifications: entities, snoozed } =
          await NotificationsController.getAll(botId);

        dispatch({
          type: this.notificationsRetrievedAction,
          entities,
          snoozed,
        });
        return entities;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  snooze(botId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        dispatch({ type: this.notificationsSnoozedAction });
        NotificationsController.snooze(botId);
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  check(botId: number, notificationId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.updateAction));

      try {
        const response = await NotificationsController.check(
          botId,
          notificationId,
        );

        dispatch(this.retrieveAll(botId));
        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }
}

export default new NotificationsCRUDActions();
